import React from 'react';

export function Print(
  props: React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  >,
) {
  return (
    <div
      {...props}
      style={{
        ...props.style,
        width: 'fit-content',
        display: 'flex',
        margin: 0,
      }}
    >
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.80005 9.4C2.80005 7.41177 4.41182 5.8 6.40005 5.8H17.6C19.5883 5.8 21.2001 7.41178 21.2001 9.4V16.6C21.2001 18.5882 19.5883 20.2 17.6 20.2H6.40005C4.41182 20.2 2.80005 18.5882 2.80005 16.6V9.4ZM6.40005 8.2C5.73731 8.2 5.20005 8.73726 5.20005 9.4V16.6C5.20005 17.2627 5.73731 17.8 6.40005 17.8H17.6C18.2628 17.8 18.8 17.2627 18.8 16.6V9.4C18.8 8.73726 18.2628 8.2 17.6 8.2H6.40005Z"
          fill="currentColor"
        />
        <path
          d="M6.86078 16.8356C6.94115 16.3534 7.35834 16 7.84718 16H16.1529C16.6418 16 17.059 16.3534 17.1393 16.8356L17.806 20.8356C17.9076 21.4451 17.4375 22 16.8196 22H7.18051C6.56257 22 6.09253 21.4451 6.19412 20.8356L6.86078 16.8356Z"
          fill="currentColor"
        />
        <path
          d="M7.00005 3C7.00005 2.44772 7.44776 2 8.00005 2H16C16.5523 2 17 2.44772 17 3V7C17 7.55228 16.5523 8 16 8H8.00005C7.44776 8 7.00005 7.55228 7.00005 7V3Z"
          fill="currentColor"
        />
        <path
          d="M8.00005 12C8.00005 11.4477 8.44776 11 9.00005 11H15C15.5523 11 16 11.4477 16 12C16 12.5523 15.5523 13 15 13H9.00005C8.44776 13 8.00005 12.5523 8.00005 12Z"
          fill="currentColor"
        />
      </svg>
    </div>
  );
}
